/**
 * /app/inbox — Global inbox (renamed from /app/messages per spec §3.1).
 * Component unchanged — Inbox from screens/inbox.tsx.
 */

import { createFileRoute } from '@tanstack/react-router';
import { Inbox } from '../../components/screens/inbox';

export const Route = createFileRoute('/app/inbox')({
  component: Inbox,
});
